import { useCatalogues } from "@sushicorp/contexts";
import { useFetchOrderHistory } from "@sushicorp/services";
import { Badge } from "artisn-ui-react";
import { useRouter } from "next/router";
import React from "react";

import ActiveOrdersPreviewPlaceholder from "./ActiveOrdersPreview.placeholder";
import Styles from "./ActiveOrdersPreview.styles";
import { ActiveOrdersPreviewProps as Props } from "./ActiveOrdersPreview.types";
import { orderDateSelectedByAllocationHelper } from "../Profile/Profile.helpers";
import Button from "components/global/Button/Button";
import ProductBasePriceInfo from "components/global/ProductBasePriceInfo/ProductBasePriceInfo";
import useAuth from "contexts/auth/auth.context.hooks";
import useI18n from "hooks/useI18n";
import { notify } from "utils/common.utils";

import ArrowRightSVG from "../../../../public/assets/images/arrow-right-black.svg";
import HistorySVG from "../../../../public/assets/images/history.svg";

const ActiveOrdersPreview: React.FC<Props> = props => {
  const t = useI18n();
  const { className, active = false } = props;
  const auth = useAuth();
  const { selectedCatalogueId: catalogueId } = useCatalogues();
  const orders = useFetchOrderHistory({
    auth,
    catalogueId,
    category: "IN_PROGRESS",
    notify
  });
  const { data: ordersInProgress, isLoading, isSuccess } = orders;
  const isEmpty = isSuccess && !ordersInProgress?.length;
  const numberOfOrders = ordersInProgress?.length ?? 0;
  const orderActive = ordersInProgress?.[0];
  const { seq_id, allocation, shoppingCart, stepName, id } = orderActive ?? {};
  const { billTotal } = shoppingCart ?? {};
  const { total } = billTotal ?? {};
  const router = useRouter();

  return (
    <Styles
      className={`ActiveOrdersPreview ${className}`}
      isEmpty={isEmpty}
      active={active}
    >
      {isLoading ? <ActiveOrdersPreviewPlaceholder /> : null}
      {isSuccess ? (
        <>
          <div
            className="ActiveOrdersPreview__header"
            onClick={() => router.push("/profile/orders")}
          >
            <h1 className="ActiveOrdersPreview__title">
              <HistorySVG />
              {t.profile.navigation.orderHistory}
            </h1>
            <Badge
              value={`${numberOfOrders}`}
              className="ActiveOrdersPreview__badge"
            >
              <ArrowRightSVG
                viewBox="0 0 22 22"
                onClick={() => router.push("/profile/orders")}
              />
            </Badge>
          </div>
          <div className="ActiveOrdersPreview__card">
            <p className="ActiveOrdersPreview__title">#{seq_id}</p>
            <p className="ActiveOrdersPreview__card__description">
              <span className="ActiveOrdersPreview__card__description-delivery">
                {allocation?.replaceAll("_", " ").toLowerCase()}
              </span>
              : {orderDateSelectedByAllocationHelper(orderActive, t)}
            </p>
            <h3 className="ActiveOrdersPreview__card__total">
              <ProductBasePriceInfo
                orderTotal={total}
                className="ActiveOrdersPreview__product-price-info"
              />
            </h3>
            <div className="ActiveOrdersPreview__buttons">
              <div className="ActiveOrdersPreview__pill-badge">{stepName}</div>
              <Button
                className="ActiveOrdersPreview__button"
                type="FILLED"
                onClick={() => router.push(`/profile/orders/${id}/${seq_id}`)}
              >
                {t.common.see}
              </Button>
            </div>
          </div>
        </>
      ) : null}
    </Styles>
  );
};

ActiveOrdersPreview.defaultProps = {
  className: ""
};

export default ActiveOrdersPreview;
